import { Typography } from "@mui/material";
import { ReactNode } from "react";

interface IValidationDetail {
    title?: string;
    errors?: Map<string, string[]>;    
}

type ValidationSummaryProps = {
    hidden?: boolean;
    validationDetail?: IValidationDetail | null;
    defaultContent?: ReactNode;
    hideTitle?: boolean;
};

const ValidationSummary = (props: ValidationSummaryProps) => {
    const { validationDetail, defaultContent } = props;

    if (validationDetail === undefined || validationDetail == null) {
        return null;
    }

    if (validationDetail.errors === undefined || validationDetail.errors.size === 0) {
        return <>{validationDetail.title ?? defaultContent}</>
    }

    if (validationDetail.errors.size === 1 && validationDetail.errors.has('*')) {
        const entries = validationDetail.errors.get('*');
        if (entries === undefined) 
            return <>{validationDetail.title ?? defaultContent}</>

        if (entries.length === 1) {
            return <>{entries[0]}</>;
        }

        return (
            <>
            {!props.hideTitle  && <Typography variant="h1">{validationDetail.title}</Typography>}
            <ul>
                { entries.map((v: string, index: number) => (
                    <li key={`${index}`}>
                        {v}
                    </li>
                ))}
            </ul>
            </>   
        );
    } else {
        let list = [] as string[];

        for (const [ key, value ] of Object.entries(validationDetail.errors)) {
            list.push(value.join(', '));
        }

        if (list.length === 1) {
            return <>{list[0]}</>;
        }

        return (
            <>
            {!props.hideTitle  && <Typography variant="h1">{validationDetail.title}</Typography>}
            <ul>
                
                { list.map((v: string, index: number) => (
                    <li key={`${index}`}>
                        {v}
                    </li>
                ))}
            </ul>
            </>
        )
    }
};

export default ValidationSummary;
